import React, { Component } from 'react'
import { Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material'
import { Mutation } from 'react-apollo'
import { upsertWastageBoundary } from '../../../station/stationWastageQueries'
import type { wastageBoundaryProps } from './wastageBoundary.types'
import WastageBoundaryRows from './WastageBoundaryRows'
import { i18n } from '../../../index'

class WastageBoundary extends Component<wastageBoundaryProps> {
  _headers = [
    {
      title: i18n.t('reporting.productGroup'),
      value: 'productType',
    },
    {
      title: i18n.t('materialLoss.lossLowerBoundary'),
      value: 'lowerWastageBounds',
    },
    {
      title: i18n.t('materialLoss.lossUpperBoundary'),
      value: 'upperWastageBounds',
    },
    {
      title: '',
      value: 'control',
    },
  ]

  render() {
    const { stationId, data, refetch } = this.props
    return (
      <div>
        <Mutation mutation={upsertWastageBoundary} fetchPolicy='network-only'>
          {(onMutation) => (
            <Table>
              <TableHead>
                <TableRow>
                  {this._headers.map((header) => (
                    <TableCell key={header.value}>{header.title}</TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                <WastageBoundaryRows
                  headers={this._headers}
                  stationId={stationId}
                  data={data}
                  onMutation={onMutation}
                  refetch={refetch}
                />
              </TableBody>
            </Table>
          )}
        </Mutation>
      </div>
    )
  }
}

export default WastageBoundary
